// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"450":"f2528a9a","453":"8701dc61"}[chunkId] + ".chunk.js";
};